import api from './client'
import type { CheckDuplicateResponse, Submission, SubmitResult } from '../types'

interface CodeValidation {
  valid: boolean
  submission_id: string | null
  file_id: string | null
}

export const submissionsApi = {
  generateCode: () => api.post<{ code: string }>('/codes/generate').then((r) => r.data),
  validateCode: (code: string) => api.post<CodeValidation>('/codes/validate', { code }).then((r) => r.data),
  get: (id: string) => api.get<Submission>(`/submissions/${id}`).then((r) => r.data),
  save: (id: string, responses: Record<string, string | string[]>) =>
    api.post<Submission>(`/submissions/${id}/save`, { responses }).then((r) => r.data),
  submit: (id: string, responses: Record<string, string | string[]>) =>
    api.post<SubmitResult>(`/submissions/${id}/submit`, { responses }).then((r) => r.data),
  checkDuplicate: (payload: { title?: string; pmc_id?: string; doi?: string }) =>
    api.post<CheckDuplicateResponse>('/check-duplicate', payload).then((r) => r.data),
}
